export function getCookieValue(a) {
  const b = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)')
  return b ? b.pop() : ''
}

export function sample(array) {
  return array[Math.floor(Math.random() * array.length)]
}
